import setCategory from '../mutators/setCategory';
import setSubCategoryState from '../mutators/setSubCategoryState';
import getCurrentSubcategory from '../selectors/getCurrentSubcategory';
import getCurrentSubcategoryLoadState from '../selectors/getCurrentSubcategoryLoadState';
import { SubCategoryState } from 'owa-options-core';

export default async function updateCategory(
    categoryKey: string,
    subcategoryKey: string,
    currentOptionKey: string
): Promise<void> {
    setCategory(categoryKey, subcategoryKey, currentOptionKey);
    const subCategory = getCurrentSubcategory();
    if (
        !subCategory.refreshOnSelected &&
        (getCurrentSubcategoryLoadState() === SubCategoryState.Loaded ||
            getCurrentSubcategoryLoadState() === SubCategoryState.Loading)
    ) {
        return;
    } else if (subCategory.onSelected) {
        setSubCategoryState(subCategory, SubCategoryState.Loading);
        let success;
        try {
            success = await subCategory.onSelected();
        } catch (e) {
            success = false;
        }
        setSubCategoryState(
            subCategory,
            success ? SubCategoryState.Loaded : SubCategoryState.Error
        );
    } else {
        setSubCategoryState(subCategory, SubCategoryState.Loaded);
    }
}
